import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-customize-report',
  templateUrl: './customize-report.component.html',
  styleUrls: ['./customize-report.component.scss'],
})
export class CustomizeReportComponent implements OnInit {
  onlineCmaList = [];
  pdfReportList = [];
  onlineForm: FormGroup;
  pdfForm: FormGroup;
  contentForm: FormGroup;
  contentTypeList = [
    {
      key: 'LetterToCustomer',
      label: 'Letter to Customer',
    },
    {
      key: 'cma',
      label: 'What is a CMA?',
    },
    {
      key: 'comparableInformation',
      label: 'comparable Information',
    },
  ];
  contentTemplates: { [key: string]: string } = {
    LetterToCustomer: ` LetterToCustomer: 
    <p>Dear new year,</p>
    <p>
      I am happy to present the Comparative Market Analysis (CMA) for the property at 
      <strong>5601 Arringdon Park Drive, Morrisville, NC 27560, USA</strong>. We have done an extensive analysis using recent 
      closed transactions and active listings of similar properties in the neighborhood to arrive at the fair market value of your property.
    </p>
    <p>
      This helps to determine a suitable listing price for your property. The fair market value of a home is determined by the price 
      at which a buyer.
    </p>
    <p>
      This CMA report includes information on current active listings and other recently sold properties in your neighborhood. 
      These are the properties.
    </p>
    <p>Yours sincerely,</p>
    <p><strong>iCMA Developer</strong></p>
  `,
    cma: `<h2>What is a CMA?</h2><p>A Comparative Market Analysis (CMA) is...</p>`,
    comparableInformation: `<h2>Comparable Information</h2><ul><li>Property 1</li><li>Property 2</li></ul>`,
  };
  themes = [
    { name: 'Beach', image: '~/../../assets/images/Beach.png' },
    { name: 'Urban', image: '~/../../assets/images/Urban.png' },
    { name: 'Suburban', image: '~/../../assets/images/Suburban.png' },
    { name: 'Cottage', image: '~/../../assets/images/Cottage.png' },
    { name: 'Countryside', image: '~/../../assets/images/Countryside.png' },
  ];
  config = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '200px',
    maxHeight: '500px',
    width: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    toolbarHiddenButtons: [['bold']],
  };

  contentOrdering: (string | string[])[] = [
    'Marketing Action Plan',
    //[
    'Letter to customer',
    'Subject Property Information',
    'Comparable Information',
    'Property Value & Net Seller Proceeds',
    // ],
    'Market Trends',
    'Inventory Analysis',
    'Importance of Intelligent Pricing & Timing',
    'Preparing Your Home',
  ];

  // todoList: (string | string[])[] = [
  //   'Marketing Action Plan',
  //   //[
  //   'Letter to customer',
  //   'Subject Property Information',
  //   'Comparable Information',
  //   'Property Value & Net Seller Proceeds',
  //   // ],
  //   'Market Trends',
  //   'Inventory Analysis',
  //   'Importance of Intelligent Pricing & Timing',
  //   'Preparing Your Home',
  // ];

  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef) {
    this.onlineCmaList = JSON.parse(JSON.stringify(this.contentOrdering));
    this.pdfReportList = JSON.parse(JSON.stringify(this.contentOrdering));

    this.onlineForm = this.fb.group({
      items: this.fb.array([]),
    });

    this.pdfForm = this.fb.group({
      items: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    this.contentForm = this.fb.group({
      contentType: [null],
      content: [''],
    });

    this.contentForm.get('contentType')?.valueChanges.subscribe((selectedType) => {
      const htmlTemplate = this.contentTemplates[selectedType] || '';
      this.contentForm.get('content')?.setValue(htmlTemplate);
    });
  }

  trackByFn(index: number, item: string | string[]): string {
    return Array.isArray(item) ? JSON.stringify(item) : item.toString();
  }

  dropOnline(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.onlineCmaList, event.previousIndex, event.currentIndex);
  }

  dropPdf(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.pdfReportList, event.previousIndex, event.currentIndex);
  }

  selectedItemsOnline: string[] = [];
  selectedItemsPdf: string[] = [];
  onlineChecked: Set<string> = new Set<any>();
  pdfChecked: Set<string> = new Set<any>();

  // Determines if an item is checked
  isChecked(type: 'online' | 'pdf', item: string): boolean {
    return type === 'online' ? this.onlineChecked.has(item) : this.pdfChecked.has(item);
  }

  // Toggles item in the checked set
  onCheckboxChange(type: 'online' | 'pdf', item: string, checked: boolean): void {
    const targetSet = type === 'online' ? this.onlineChecked : this.pdfChecked;
    if (checked) {
      targetSet.add(item);
    } else {
      targetSet.delete(item);
    }
  }

  isArray(item: any): boolean {
    return Array.isArray(item);
  }

  setDefault(themeName: string) {
    console.log(`${themeName} theme set as default`);
  }

  viewTheme(themeName: string) {
    console.log(`Viewing ${themeName} theme`);
  }

  submit() {
    // const onlineResult = this.onlineCmaList.map((item) => ({
    //   name: item,
    //   checked: this.onlineChecked.has(item),
    // }));
    // const pdfResult = this.pdfReportList.map((item) => ({
    //   name: item,
    //   checked: this.pdfChecked.has(item),
    // }));
    // console.log(this.onlineCmaList, this.pdfReportList, '................');
    // console.log(this.onlineChecked, this.pdfChecked, '................');
    // console.log('🟦 Online CMA Report:', onlineResult);
    // console.log('📄 PDF Report:', pdfResult);
  }
}
